<ul class="breadcrumb">
    <li *ngFor="let item of items">
        <ng-container *ngIf="item.url">
            <a class="light link" [routerLink]="item.url" [queryParams]="item.params">{{item.label}}</a>
        </ng-container>
        <ng-container *ngIf="!item.url"><span class="light ">{{item.label}}</span></ng-container>
    </li>
</ul>